const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
console.log("API Base URL:", API_BASE_URL);

export const getDomains = async (option) => {
  const { signal } = option.controller;

  let result = [];
  for (let mapResource of option.mapResources) {
    let resDomains;
    if (mapResource.url) {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/${mapResource.resourceType}/domains${mapResource.url}?sourceId=${mapResource.sourceId}`,
          { signal }
        );
        resDomains = await response.json();
      } catch (error) {
        if (error.name === "AbortError") {
          console.log(`Request for option ${option.id} was canceled.`);
        } else {
          console.error("Error fetching data:", error);
        }
      }
    } else {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/${mapResource.resourceType}/domains?variable=${option.variable}&sourceId=${mapResource.sourceId}`,
          { signal }
        );
        resDomains = await response.json();
      } catch (error) {
        if (error.name === "AbortError") {
          console.log(`Request for option ${option.id} was canceled.`);
        } else {
          console.error("Error fetching data:", error);
        }
      }
    }

    if (Array.isArray(resDomains)) {
      resDomains = resDomains.map((r) => {
        return { ...r, domainType: mapResource.resourceType };
      });
      result = result.concat(resDomains);
    } else {
      resDomains = { ...resDomains, domainType: mapResource.resourceType };
      result.push(resDomains);
    }
  }

  result = result.map((d) => {
    return { ...d, option };
  });
  return {
    heatmapDomains: result.filter((d) => d.domainType == "heatmap"),
    particlesDomains: result.filter((d) => d.domainType == "particles"),
    tilemapDomains: result.filter((d) => d.domainType == "tilemap"),
    geoJSONDomains: result.filter((d) => d.domainType == "geojson"),
    sensorDomains: result.filter((d) => d.domainType == "sensor"),
  };
};
